import { alias } from '@ember/object/computed';
import RGBAColor from '@square/dashboard-data/models/squareup/common/rgba-color';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  categoryName: attr(String),
  sku: attr(String),
  imageURL: alias('imageUrl'),
  imageUrl: attr(String),
  iconColor: attr(RGBAColor)
});